module.exports = __webpack_public_path__ + "static/media/our-comp-img-romeo.8eee5fc8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/our-companies/our-comp-img-romeo.png
// module id = 325
// module chunks = 0